import { Outlet, useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import { errorSelector, errorActions } from '@/store/reducers/error';
import UseCheckAuth from '@/admin/hooks/UseCheckAuth';
import AppLoader from '@/admin/components/AppLoader/AppLoader';
import GenericErrorModal from '@/components/GenericErrorModal/GenericErrorModal';
import { useEffect, useState } from 'react';
import { useDrawer } from '@/admin/context/DrawerContext';
import Drawer from 'react-modern-drawer';
import ContactUsDrawer from '@/components/ContactUsDrawer/ContactUsDrawer';
import adminCommon from '@/school-management/utils/common';
import NotificationsPopup from '@/components/Notifications/NotificationsPopup/NotificationsPopup';
import OfflineNotification from '@/components/OfflineNotification/OfflineNotification';
import MobileBlocker from '@/components/MobileBlocker/MobileBlocker';

function App() {
  const [isAppLoaded, setIsAppLoaded] = useState<boolean>(false);
  const { appLoaded, user } = useAppSelector(authSelector);
  const errorState = useAppSelector(errorSelector);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const drawer = useDrawer();
  UseCheckAuth();

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setIsAppLoaded(appLoaded);
      },
      appLoaded ? 1000 : 0
    );

    return () => {
      clearTimeout(timer);
    };
  }, [appLoaded]);

  const handleCloseError = () => {
    const { navigateOnClose } = errorState;
    dispatch(errorActions.hideError());
    if (navigateOnClose) {
      if (navigateOnClose === 'refresh') {
        window.location.reload();
      } else {
        navigate(navigateOnClose);
      }
    }
  };

  return (
    <>
      {isAppLoaded ? <Outlet /> : <AppLoader />}
      <GenericErrorModal
        show={errorState.show}
        title={errorState.title}
        message={errorState.message}
        i18nKey={errorState.i18nKey}
        eyebrow={errorState.eyebrow}
        buttonText={errorState.buttonText}
        icon={errorState.icon}
        onClose={handleCloseError}
      />
      <OfflineNotification />
      <NotificationsPopup />
      {user && (
        <Drawer
          open={drawer.isContactUsDrawerOpen}
          onClose={drawer.closeContactUsDrawer}
          direction='right'
          className='app-drawer app-drawer--contact-us'
          size='clamp(320px, 30vw, 580px)'
        >
          <ContactUsDrawer
            isOpen={drawer.isContactUsDrawerOpen}
            onClose={drawer.closeContactUsDrawer}
            showGlobalError={adminCommon.showGlobalError}
          />
        </Drawer>
      )}
      <MobileBlocker />
    </>
  );
}

export default App;
